import { render, staticRenderFns } from "./popover-tip.vue?vue&type=template&id=63d491c4&scoped=true&"
import script from "./popover-tip.vue?vue&type=script&lang=js&"
export * from "./popover-tip.vue?vue&type=script&lang=js&"
import style0 from "./popover-tip.vue?vue&type=style&index=0&id=63d491c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d491c4",
  null
  
)

export default component.exports